import { de_DE_formal } from "@App/locales/de_DE-formal";
import { de_DE_globalTranslations } from "@App/locales/de_DE-globalTranslations";

export const fleethub = {
  ...de_DE_formal,
  ...{
    translation: {
      ...de_DE_globalTranslations.translation,
      layout: {
        backText: "Zurück zu fleethub.de",
      },
      linkToHome: "https://werkstatt.repareo.de/partner/fleethub",
      hint: {
        text: "Alle gezeigten Werkstätten sind offizielle FLEET HUB Service-Partner. Bitte beachten Sie bei der Buchung Ihre Fuhrpark Richtlinien.",
        "repareo-inspection-text":
          "Alle gezeigten Werkstätten führen die Inspektion nach Herstellervorgaben durch und erhalten Ihre Gewährleistung.",
      },
    },
  },
};
